import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import "./DateFilterOffcanvas.css";

function DateFilterOffcanvas({ show, handleClose, onApplyDate }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [showPicker, setShowPicker] = useState(false);

  const daysInMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0,
  ).getDate();

  const firstDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  ).getDay();

  const monthYear = currentDate.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = [];
  for (let y = 2000; y <= 2035; y++) {
    years.push(y);
  }

  const prevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1),
    );
  };

  const nextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1),
    );
  };

  const renderDays = () => {
    const days = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={"empty-" + i} className="empty_day"></div>);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const isSelected =
        selectedDate &&
        selectedDate.getDate() === i &&
        selectedDate.getMonth() === currentDate.getMonth() &&
        selectedDate.getFullYear() === currentDate.getFullYear();

      days.push(
        <div
          key={i}
          className={`calendar_day ${isSelected ? "active" : ""}`}
          onClick={() =>
            setSelectedDate(
              new Date(currentDate.getFullYear(), currentDate.getMonth(), i),
            )
          }
        >
          {i}
        </div>,
      );
    }

    return days;
  };

  const selectMonth = (monthIndex) => {
    setCurrentDate(new Date(currentDate.getFullYear(), monthIndex, 1));
  };

  const selectYear = (year) => {
    setCurrentDate(new Date(year, currentDate.getMonth(), 1));
  };

  const handleApply = () => {
    if (selectedDate) {
      const formatted = selectedDate.toLocaleDateString("en-GB");
      onApplyDate(formatted); // send to parent
    }
    handleClose();
  };

  return (
    <section className="date_filter_parent">
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="bottom"
        className="date_offcanvas common_offcanvas "
      >
        <Offcanvas.Body>
          <div className="calendar_container">
            {/* Header */}
            <div className="calendar_header" style={{ position: "relative" }}>
              <span onClick={prevMonth}>&lsaquo;</span>

              <h5
                onClick={() => setShowPicker(!showPicker)}
                style={{ cursor: "pointer" }}
              >
                {monthYear.toUpperCase()}
              </h5>

              <span onClick={nextMonth}>&rsaquo;</span>
            </div>

            {/* Month & Year Picker */}
            {showPicker && (
              <div
                style={{
                  position: "absolute",
                  top: "-55%",
                  left: "0",
                  right: "0",
                  background: "#fff",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  borderRadius: "8px",
                  padding: "10px",
                  zIndex: 1000,
                  display: "flex",
                  gap: "10px",
                }}
              >
                {/* Month List */}
                <div
                  style={{
                    flex: 1,
                    maxHeight: "160px",
                    overflowY: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                  {months.map((m, index) => (
                    <div
                      key={m}
                      className="calendar_day"
                      onClick={() => {
                        selectMonth(index);
                        setShowPicker(false);
                      }}
                    >
                      {m}
                    </div>
                  ))}
                </div>

                {/* Year List */}
                <div
                  style={{
                    flex: 1,
                    maxHeight: "160px",
                    overflowY: "auto",
                    scrollbarWidth: "none",
                  }}
                >
                  {years.map((y) => (
                    <div
                      key={y}
                      className="calendar_day"
                      onClick={() => {
                        selectYear(y);
                        setShowPicker(false);
                      }}
                    >
                      {y}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Week Days */}
            <div className="week_days">
              {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map(
                (day, i) => (
                  <div key={i}>{day}</div>
                ),
              )}
            </div>

            {/* Calendar Grid */}
            <div className="calendar_grid">{renderDays()}</div>

            {/* Buttons */}
            <div className="calendar_buttons">
              <button className="btn-register" onClick={handleClose}>
                Cancel
              </button>
              <button className="btn_register_bg" onClick={handleApply}>
                Apply
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
}

export default DateFilterOffcanvas;
